export default "__VITE_ASSET__33f95834__"